/**
 * @param {Record<string, any>} [lang]
 * @param {import('@tidal/user-models').ApiErrorCode} [errorCode]
 * @returns {string}
 */
export default function getUserErrorMessage(lang, errorCode) {
    if (!lang) {
        return 'Something went wrong, please try again. If the error persists, please contact customer support.';
    }

    switch (errorCode) {
        case 'ACTIVE_SUBSCRIPTION_PARTNER': return lang.error.activeSubscriptionPartner.message;
        case 'DEVICE_CODE_EXPIRED': return lang.device.deviceCodeExpired;
        case 'EMAIL_DOES_NOT_MATCH': return lang.error.emailUnmatch.message;
        case 'NEW_PASSWORD_NOT_VALID': return lang.error.invalidCharInPass.message;
        case 'OFFER_NO_LONGER_VALID': return lang.error['404'].message;
        case 'OFFER_NOT_ELIGIBLE': return lang.error.notEligible.message;
        case 'OLD_PASSWORD_DOES_NOT_MATCH': return lang.error.oldPassNotSameAsNew.message;
        case 'ONLY_VIVACOM_BG': return lang.error.vivacomBgBulgariaOnly.message;
        case 'PARTNER_ORDER_CANCELED': return lang.error.orderCancelled.message;
        case 'PARTNER_ORDER_EXPIRED': return lang.error.orderExpired.message;
        case 'PARTNER_ORDER_NOT_FOUND': return lang.partner.orderNotFound;
        case 'PARTNER_ORDER_USED': return lang.error.orderUsed.message;
        case 'PHONE_NUMBER_NOT_VALID': return lang.partner.phoneNumberNotValid;
        case 'PROVIDE_DEVICE_CODE': return lang.device.provideDeviceCode;
        case 'SHEERID_MAX_DOCUMENTS_LIMIT': return lang.lang.sheerid.maxDocuments;
        case 'SHEERID_TOKEN_EXPIRED': return lang.error.sheeridTokenExpired.message;
        case 'SHEERID_VERIFICATION_ERROR': return lang.sheerid.verificationError;
        case 'SHEERID_WRONG_DOC_TYPE': return lang.sheerid.wrongFileError;
        case 'SUBSCRIPTION_ALREADY_EXISTS_FOR_USER': return lang.msisdn.error.subscriptionAlreadyExists;
        case 'UNAUTHORIZED': return lang.error.unauthorized.message;
        case 'VOUCHER_COUNTRY_NOT_ELIGIBLE': return lang.voucher.countryNotEligible;
        case 'VOUCHER_NOT_ELIGIBLE_FOR_CODE': return lang.voucher.notEligibleForCode;
        case 'VOUCHER_NOT_VALID': return lang.voucher.notValid;
        case 'WRONG_DEVICE_CODE': return lang.device.deviceCodeWrong;
        case 'WRONG_PIN_CODE': return lang.partner.pinCodeWrong;
        case 'GENERIC_ERROR':
        default: return lang.error.generic.message;
    }
}
